<template>
  <div class="page-container invest">
    <van-nav-bar fixed @click-left="onLeft" @click-right="onRight" :z-index="10">
      <template #left>
        <button ref="left" class="nav-button-left" :style="updateNavLeftStatus">
          委托拍品
        </button>
      </template>
      <template #right>
        <button ref="right" class="nav-button-right" :style="updateNavRightStatus">
          竞买拍品
        </button>
      </template>
    </van-nav-bar>
    <auction-assets v-if="selectNavIndex == 0"></auction-assets>
    <AuctionAssets1 v-else></AuctionAssets1>
    <!-- <tian-products-regular v-else></tian-products-regular> -->
  </div>
</template>

<script>
import { Tab, Tabs, Icon } from "vant"
import TianVipRegular from "./components/vip-regular"
import TianProductsRegular from "./components/products-regular"
import { mapGetters } from "vuex"
import AuctionAssets from "./components/auction-assets.vue"
import AuctionAssets1 from "./components/auction-assets1.vue"
import session from "../../utils/session"

export default {
  name: "Invest",
  components: {
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Icon.name]: Icon,
    TianVipRegular,
    TianProductsRegular,
    AuctionAssets,
    AuctionAssets1
  },

  data() {
    return {
      activeName: "定期产品",
      selectNavIndex: 0 // 导航栏状态：0 债权资产 1 拍卖资产
    }
  },
  beforeMount() {
    if (session.get("invest-nav-index")) {
      this.selectNavIndex = Number(session.get("invest-nav-index"))
    }
  },
  beforeUpdate() { },
  computed: {
    ...mapGetters(["userInfo", "channel"]),
    updateNavLeftStatus() {
      if (this.selectNavIndex == 0) {
        return { color: "rgb(250, 80, 26)" }
      } else {
        return { color: "rgb(0, 0, 0)" }
      }
    },
    updateNavRightStatus() {
      if (this.selectNavIndex == 0) {
        return { color: "rgb(0, 0, 0)" }
      } else {
        return { color: "rgb(250, 80, 26)" }
      }
    }
  },
  methods: {
    onLeft() {
      this.selectNavIndex = 0
      this.saveNavSelect()
    },
    onRight() {
      this.selectNavIndex = 1
      this.saveNavSelect()
    },
    saveNavSelect() {
      session.set("invest-nav-index", this.selectNavIndex)
    }
  }
}
</script>

<style scoped lang="less">
.page-container {
  padding-top: 46px !important;
}

::v-deep .van-nav-bar__title {
  font-size: 15px;
  color: #333;
  font-weight: 700;
}

.nav-button-left {
  border: 0 solid white;
  background-color: white;
  text-align: center;
  margin-left: 30px;
  margin-top: 10px;
  font-size: 17px;
  font-weight: 700;
  color: rgb(250, 80, 26);
}

.nav-button-right {
  border: 0 solid white;
  background-color: white;
  text-align: center;
  margin-right: 30px;
  margin-top: 10px;
  font-size: 17px;
  font-weight: 700;
  color: black;
}

@import url("./idx.less");
</style>
